/**
 * Path segment of the Themis Intake handoff API, appended to the configured
 * base host (`env.themisIntake.url`). All handoff endpoints hang from here.
 */
export const HANDOFF_API_PATH = '/themis/intake/v1/handoff';

/** Query param carrying the opaque, single-use launch token (TTL ~2 min). */
export const LAUNCH_TOKEN_QUERY_PARAM = 'launch_token';

/**
 * Polling budget owned by the frontend (failsafe, independent of the backend).
 * Once exhausted we fall back to the "we'll email you" screen.
 */
export const POLL_BUDGET_MS = 15000;
export const POLL_INTERVAL_MS = 1500;
export const POLL_MAX_INTERVAL_MS = 3000;
export const POLL_BACKOFF_FACTOR = 1.5;

/**
 * Minimum time the loading screen stays visible before transitioning, so a fast
 * operation doesn't make it flash. It's a floor, not an added delay: if the flow
 * already took longer, there's no extra wait.
 */
export const MIN_LOADING_MS = 4000;

/**
 * Minimum loading time before falling back to the email screen specifically.
 * Longer than MIN_LOADING_MS on purpose: even when we already know it failed
 * (e.g. an immediate 401 on redeem), showing the loading screen a bit longer
 * reads better than an instant bounce to the fallback.
 */
export const MIN_LOADING_MS_ON_FAILURE = 15000;

/**
 * Caps the band the content is centered in. Without it, a very tall viewport
 * splits all the leftover height evenly and the stack drifts far down the page;
 * with it, the extra space beyond this height stays at the bottom.
 */
export const CENTERED_BAND_MAX_HEIGHT = 'min(680px, max(480px, 100vw))';
